$(function() {

  $(window).scroll( function() {
    const scroll = $(window).scrollTop();
    const SiteHeader = $( '#site-header' );
    const SiteHeaderInner = $( '#site-header-inner' );
    const SiteDescription = $( '#site-description' );
    const MenuToggle = $( '#menu-toggle' );
    // Hide nav on scroll
    if ( scroll >= 100 ) {
      SiteHeader.addClass( 'shrink' );
      MenuToggle.addClass( 'shrink' );
      SiteHeaderInner.addClass( 'shrink' );
      SiteDescription.addClass( 'shrink' );
    } else {
      SiteHeader.removeClass( 'shrink' );
      MenuToggle.removeClass( 'shrink' );
      SiteHeaderInner.removeClass( 'shrink' );
      SiteDescription.removeClass( 'shrink' );
    }
  });
});

